import axios from '@utils/http'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getRoles({ commit, dispatch, getters }, { queryTerms, search } = {}) {
    return axios
      .get('/api/roles', { params: { ...queryTerms, search } })
      .then(response => {
        return response.data
      })
  },

  addRole({ commit, state, rootState }, { role } = {}) {
    return axios.post('/api/roles', role)
  },

  updateRole({ commit, state, rootState }, { role } = {}) {
    return axios.put(`/api/roles/${role.id}`, role)
  },

  addUsersToRole({ commit, state, rootState }, { roleId, users } = {}) {
    return axios.post(`/api/roles/${roleId}/addUsers`, { roleId, users })
  },

  removeUsersFromRole({ commit, state, rootState }, { roleId, users } = {}) {
    return axios.post(`/api/roles/${roleId}/removeUsers`, { roleId, users })
  },

  deleteRole({ commit, state, rootState }, { role } = {}) {
    return axios.delete(`/api/roles/${role.id}`)
  },

  getRolesWithoutWorkflow(
    { commit, dispatch, getters },
    { queryTerms, search } = {}
  ) {
    return axios
      .get('/api/approverWorkflows/rolesWithoutWorkflow', {
        params: { ...queryTerms, search },
      })
      .then(response => {
        return response.data
      })
  },
}
